// extracted by mini-css-extract-plugin
module.exports = {"showMore":"_3B-Lp"};